import React from "react";
import "./NewOrLoadPage.scss";
import logoW from "assets/images/cmr-logo-b1.png";
import { Button, ButtonProps } from "@mui/material";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import FeedOutlinedIcon from "@mui/icons-material/FeedOutlined";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { styled } from "@mui/material/styles";
import { useHistory } from "react-router-dom";
import RoutesName from "routes/routesName";

const ColorButton = styled(Button)<ButtonProps>(() => ({
    boxShadow: "none",
    textTransform: "none",
    fontSize: 18,
    fontWeight: "bold",
    border: "1px solid",
    color: "#02334E",
    borderRadius: "50px",
    lineHeight: 1.5,
    backgroundColor: "#FFFFFF",
    borderColor: "#FFFFFF",
    fontFamily: [
        "Open Sans",
        "-apple-system",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
    ].join(","),
    "&:hover": {
        backgroundColor: "#E6117B",
        borderColor: "#E6117B",
        boxShadow: "none",
        color: "#fff",
    },
    "&:active": {
        boxShadow: "none",
        backgroundColor: "#E6117B",
        borderColor: "#E6117B",
    },
    "&:focus": {
        boxShadow: "0 0 0 0.2rem rgba(230, 17,123,.2)",
    },
}));

const NewOrLoadPage: React.FC = (): JSX.Element => {
    const router = useHistory();
    const handleClick = (type: string): void => {
        if (type === "new") {
            router.push({ pathname: RoutesName.newSetup });
        }
        if (type === "load") {
            router.push({ pathname: RoutesName.preset });
        }
        if (type === "import") {
            router.push({ pathname: RoutesName.import });
        }
    };
    return (
        <div className="newOrLoadPage">
            <section className="newLoadCard">
                <div className="cardLogo">
                    <img src={logoW} alt="CMR - Logo" />
                </div>
                <div className="cardBody">
                    <ColorButton
                        onClick={() => handleClick("new")}
                        variant="contained"
                        startIcon={<AddCircleOutlineOutlinedIcon className="icon" />}
                    >
                        New Setup
                    </ColorButton>

                    <ColorButton
                        onClick={() => handleClick("load")}
                        variant="contained"
                        startIcon={<FeedOutlinedIcon className="icon" />}
                    >
                        Load Setup
                    </ColorButton>

                    <ColorButton
                        onClick={() => handleClick("import")}
                        variant="contained"
                        startIcon={<CloudUploadOutlinedIcon className="icon" />}
                    >
                        Import Setup
                    </ColorButton>
                </div>
            </section>
        </div>
    );
};

export default NewOrLoadPage;
